import { create } from 'zustand';
import type { User } from 'firebase/auth';

interface AuthState {
  user: User | null;
  userToken: string | null;
  isLoading: boolean;
  setUser: (user: User | null, token: string | null) => void;
  setLoading: (isLoading: boolean) => void;
}

interface AuthStateActions {
  setUser: (user: User | null, token: string | null) => void;
  setLoading: (isLoading: boolean) => void;
}

const initialState: Omit<AuthState, keyof AuthStateActions> = {
  user: null,
  userToken: null,
  isLoading: true,
};

class AuthStoreActions implements AuthStateActions {
  constructor(private set: (partial: Partial<AuthState>) => void) {}

  setUser = (user: User | null, token: string | null) => {
    this.set({ user, userToken: token });
  };

  setLoading = (isLoading: boolean) => {
    this.set({ isLoading });
  };
}

export const useAuthStore = create<AuthState>((set) => ({
  ...initialState,
  ...new AuthStoreActions(set),
}));
